import { securedAxiosInstance } from "../axios";

class IbanService {
  get() {
    return securedAxiosInstance.get("/iban");
  }

  update(payload) {
    return securedAxiosInstance.patch("/iban", payload, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  confirm() {
    return securedAxiosInstance.post("/iban/confirm");
  }

  extract(payload) {
    return securedAxiosInstance.post("/iban/extract", payload, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
}

export default new IbanService();
